(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal, .mt-pasos-grid');
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      observador.observe(el);
    });
  }

  function initHotspots(raiz) {
    (raiz || document).querySelectorAll('[data-mt-hotspots]').forEach(function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';
      var puntos = bloque.querySelectorAll('[data-mt-punto]');
      var items = bloque.querySelectorAll('[data-mt-item]');
      function activar(i) {
        puntos.forEach(function (p) { p.classList.toggle('mt-activo', p.dataset.mtPunto === i); });
        items.forEach(function (it) {
          var on = it.dataset.mtItem === i;
          it.classList.toggle('mt-activo', on);
          it.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      puntos.forEach(function (p) {
        p.addEventListener('click', function () { activar(p.dataset.mtPunto); });
        p.addEventListener('mouseenter', function () { activar(p.dataset.mtPunto); });
      });
      items.forEach(function (it) {
        it.addEventListener('click', function () { activar(it.dataset.mtItem); });
        it.addEventListener('mouseenter', function () { activar(it.dataset.mtItem); });
      });
      if (items[0]) activar(items[0].dataset.mtItem);
    });
  }

  function initModelos(raiz) {
    (raiz || document).querySelectorAll('[data-mt-modelos]').forEach(function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';
      var tabs = bloque.querySelectorAll('[data-mt-tab]');
      function activar(i) {
        bloque.querySelectorAll('[data-mt-tab],[data-mt-panel],[data-mt-foto]').forEach(function (el) {
          var id = el.dataset.mtTab || el.dataset.mtPanel || el.dataset.mtFoto;
          el.classList.toggle('mt-activo', id === i);
          if (el.dataset.mtTab) el.setAttribute('aria-selected', id === i ? 'true' : 'false');
        });
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { activar(t.dataset.mtTab); }); });
    });
  }

  function initFaq(raiz) {
    (raiz || document).querySelectorAll('.mt-faq-item').forEach(function (item) {
      if (item.dataset.mtInit) return;
      item.dataset.mtInit = '1';
      var boton = item.querySelector('.mt-faq-q');
      if (!boton) return;
      boton.addEventListener('click', function () {
        var abierto = item.classList.toggle('mt-abierto');
        boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-mt-producto]').forEach(function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';
      var principal = bloque.querySelector('[data-mt-principal]');
      var minis = bloque.querySelectorAll('[data-mt-mini]');
      function mostrar(src, alt) {
        if (!principal) return;
        principal.src = src;
        if (alt != null) principal.alt = alt;
        minis.forEach(function (m) { m.classList.toggle('mt-activo', m.dataset.mtMini === src); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { mostrar(m.dataset.mtMini, m.dataset.mtAlt); });
      });

      var datos = bloque.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var form = bloque.querySelector('form[action*="/cart/add"]');
      var inputId = form && form.querySelector('input[name="id"]');
      var boton = bloque.querySelector('[data-mt-comprar]');
      var precio = bloque.querySelector('[data-mt-precio]');
      var tachado = bloque.querySelector('[data-mt-tachado]');
      var textoComprar = boton ? boton.dataset.mtTexto : '';
      var textoAgotado = boton ? boton.dataset.mtAgotado : '';
      var formato = bloque.dataset.mtMoneda || '{{amount}}';

      function dinero(centimos) {
        var v = (centimos / 100).toFixed(2);
        var coma = v.replace('.', ',');
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centimos / 100))
          .replace(/\{\{\s*amount\s*\}\}/, v);
      }

      function actualizar() {
        var elegidas = [];
        bloque.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
          var marcado = grupo.querySelector('input:checked');
          elegidas.push(marcado ? marcado.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.textContent = dinero(v.compare_at_price); tachado.hidden = false; }
          else { tachado.hidden = true; }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoComprar : textoAgotado;
        }
        if (v.featured_image && v.featured_image.src) mostrar(v.featured_image.src, v.featured_image.alt);
      }
      bloque.querySelectorAll('[data-mt-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });
    });
  }

  function initTodo(e) {
    var raiz = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(raiz);
    initHotspots(raiz);
    initModelos(raiz);
    initFaq(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
